<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10" v-if="formData.defectIssuesCode">
        <el-col :span="24">
          <div class="mb-1">
            <el-tag
              class="mt-1"
              size="mini"
              :type="
                formData.status === 'Y'
                  ? 'success'
                  : formData.status === 'N'
                  ? 'danger'
                  : 'primary'
              "
            >
              {{ formData.v_status || '--' }}
            </el-tag>
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266">
              Update：{{ formData.modifyByName ? formData.modifyByName : '--' }}
              at
              {{ formData.modifyTime || '--' }}
            </span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_issueType') || '问题类型'"
            prop="issueType"
          >
            <dict-select
              v-model="formData.issueType"
              size="small"
              filterable
              :body="{ dictType: 'inspectionIssueType' }"
              url="/sys/common/dict/system"
              :placeholder="$l('tips_select_issueType') || '请选择问题类型'"
              @change="getGroupList"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_defectIssuesGroup') || '疵点问题组'"
            prop="defectIssuesGroup"
          >
            <el-select
              v-model.trim="formData.defectIssuesGroup"
              filterable
              allow-create
              default-first-option
              style="width: 100%"
              :placeholder="
                $l('tips_input_defectIssuesGroup_placeholder') ||
                  '请选择或创建疵点问题组'
              "
            >
              <el-option
                v-for="item in options"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_defectIssuesTitle') || '疵点问题标题'"
            prop="defectIssuesTitle"
          >
            <el-input
              clearable
              v-model.trim="formData.defectIssuesTitle"
              :placeholder="
                $l('tips_input_defectIssuesTitle_placeholder') ||
                  '请输入疵点问题标题'
              "
              size="small"
              maxlength="255"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    defectIssuesCode: String,
    params: { type: Object, default: () => {} },
  },
  data() {
    const issuesGroupValidator = (rule, value, callback) => {
      if (value && value.length > 50) {
        callback(
          new Error(
            this.$l('tips_input_defectIssuesGroup_maxLength') ||
              '疵点问题组名称不能超过 50 个字符'
          )
        )
      } else {
        callback() // 通过
      }
    }
    return {
      formData: { defectIssuesGroup: '' },
      options: [],

      rules: {
        defectIssuesGroup: [
          {
            required: true,
            message:
              this.$l('tips_input_defectIssuesGroup_placeholder') ||
              '请输入疵点问题组',
            trigger: 'blur',
          },
          { validator: issuesGroupValidator, trigger: 'blur' }, // 长度校验
        ],
        defectIssuesTitle: [
          {
            required: true,
            message:
              this.$l('tips_input_defectIssuesTitle_placeholder') ||
              '请输入疵点问题标题',
            trigger: 'blur',
          },
        ],
        issueType: [
          {
            required: true,
            message:
              // this.$l('tips_input_defectIssuesTitle_placeholder') ||
              '请输入问题类型',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.defectIssuesCode) return
      this.$api
        .mrpInspectionDefectIssuesDetailApi({
          defectIssuesCode: this.defectIssuesCode,
        })
        .then((res) => {
          this.formData = res.body
          this.getGroupList({ clear: false })
        })
    },
    getGroupList({ clear = true }) {
      if (!this.formData.issueType) return
      if (clear) {
        this.formData.defectIssuesGroup = ''
      }
      this.$api
        .mrpInspectionDefectIssuesGroupApi({
          issueType: this.formData.issueType,
        })
        .then((res) => {
          this.options = res.body.data
        })
        .catch(() => {})
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .mrpInspectionDefectIssuesSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
